// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Source: business/ishvaram/data/commerce/report_plans.snapshot.json

import type { PremiumReportPlanId } from "./reportPlans";

/** Bundle-light display facts for acquisition CTAs. */
export interface ReportPlanSummary {
  id: PremiumReportPlanId;
  name: string;
  price_inr: number;
  pages: number;
}

export const reportPlanSummaries: readonly ReportPlanSummary[] = [
  {
    id: "brihat_kundali",
    name: "Brihat Kundali Report",
    price_inr: 199,
    pages: 51,
  },
  {
    id: "career_report",
    name: "Career & Finance Report",
    price_inr: 149,
    pages: 28,
  },
  {
    id: "marriage_report",
    name: "Marriage & Compatibility Report",
    price_inr: 149,
    pages: 10,
  },
  {
    id: "annual_forecast",
    name: "Annual Forecast 2026-27",
    price_inr: 149,
    pages: 17,
  },
  {
    id: "muhurat_report",
    name: "Personal Muhurat & Sankalp Plan",
    price_inr: 149,
    pages: 17,
  },
  {
    id: "dosha_remedy_plan",
    name: "Dosha Diagnosis & Remedy Plan",
    price_inr: 199,
    pages: 18,
  },
  {
    id: "sade_sati",
    name: "Sade Sati Personal Report",
    price_inr: 149,
    pages: 13,
  },
  {
    id: "pitra_dosh",
    name: "Pitra Dosh Personal Report",
    price_inr: 149,
    pages: 12,
  },
  {
    id: "mahadasha_forecast",
    name: "12-Month Mahadasha Forecast",
    price_inr: 199,
    pages: 16,
  },
  {
    id: "numerology_report",
    name: "Numerology Life Report",
    price_inr: 149,
    pages: 10,
  },
  {
    id: "gemstone_report",
    name: "Rudraksha & Ratna Recommendation",
    price_inr: 199,
    pages: 12,
  },
  {
    id: "baby_name_report",
    name: "Baby Name Report",
    price_inr: 199,
    pages: 12,
  },
  {
    id: "lal_kitab_report",
    name: "Lal Kitab Remedy Report",
    price_inr: 149,
    pages: 12,
  },
  {
    id: "transit_forecast",
    name: "Gochar Transit Forecast",
    price_inr: 199,
    pages: 14,
  },
  {
    id: "mahadasha_forecast_winback",
    name: "12-Month Mahadasha Forecast",
    price_inr: 49,
    pages: 16,
  },
  {
    id: "sade_sati_winback",
    name: "Sade Sati Personal Report",
    price_inr: 49,
    pages: 13,
  },
  {
    id: "ask_one_question",
    name: "Ask One Question",
    price_inr: 49,
    pages: 1,
  },
] as const;

export const reportPlanSummaryMap: Readonly<Record<PremiumReportPlanId, ReportPlanSummary>> =
  Object.fromEntries(reportPlanSummaries.map((plan) => [plan.id, plan])) as Record<
    PremiumReportPlanId,
    ReportPlanSummary
  >;
